<template>
  <section>
    <el-row>
      <el-col class="space">
        <CompanyList @comSelected="comSelected" :com-id="comId" :com-name="comName" :option="option"></CompanyList>
      </el-col>
      <el-col class="space">
        <el-select clearable v-model="pId" placeholder="请选择项目" @change="proSelected" @clear="proClear">
          <el-option v-for="(item,index) in proData" :key="item.id" :label="item.proName" :value="item.id"></el-option>
        </el-select>
      </el-col>
      <el-col class="space">
          <el-select clearable v-model="rId" placeholder="请选择上级岗位" @change="roleSelected" @clear="roleClear">
            <el-option v-for="(item,index) in roleData" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
          </el-select>
      </el-col>
    </el-row>

  </section>
</template>

<script>
  import CompanyList from "./CompanyList";
  import RoleList from "./RoleList";
  import {proSearch, roleParent,roleIsParent} from '../../api/api'

  export default {
    name: "LinkageRole",
    components: {CompanyList, RoleList},
    props: {
      comId:null,
      comName:null,
      proId:null,
      roleId:null,
      roleName:null,
      roleCurrentId:null,
      option:0,
    },
    data() {
      return {
        cId: null,
        proData: [],
        pId: null,
        roleData: [],
        rId: null,
        rName:'',
        isRoleShow:true
      }
    },
    methods: {
      //更改公司时加载对应公司项目.岗位
      comSelected: function (id, value) {
        if (id != null) {
          this.cId = id; //公司编号
          //加载该公司下的所有项目包括 下级公司项目
          let params = {page: 1, limit: 10000, comId: id};//请求参数
          proSearch(params, this.GLOBAL.header).then(result => {
            if (result.success) {
                this.proData = result.data.result;
                if(this.option == 0){
                  this.proClear();
                }else {
                  this.pId = this.proId;
                }
              //加载岗位
              if(this.pId!=null && this.pId=='')
              {
                this.pId = null;
              }
              let roleParams = {comId: this.cId,proId:this.pId};//请求参数
              roleParent(roleParams, this.GLOBAL.header).then(result => {
                if (result.success) {
                  this.roleData = result.data;
                  if(this.option == 0){
                    this.roleClear();
                  }else {
                    if(this.roleId !=0){
                      this.rId = this.roleId;
                      this.$emit('roleSelected',this.rId);
                    }
                  }
                }
              });
            }
          });

        }else {
          this.proClear();
          this.proData=[];
          this.roleClear();
          this.roleData=[];
        }
        this.$emit('comSelected',this.cId);
      },
      //更改项目时加载对应项目
      proSelected: function () {
        //加载岗位
        if(this.pId!=null && this.pId=='')
        {
          this.pId = null;
        }
        let roleParams = {comId: this.cId,proId:this.pId};//请求参数
        roleParent(roleParams, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.roleData = result.data;
            this.roleClear();
          }
        });
        this.$emit('proSelected',this.pId);
      },
      //更改角色
      roleSelected: function () {
        if(this.option==1){
          //是否允许修改
          if(this.rId == this.roleCurrentId){
            this.$message({
              message: "不能选择自己作为上级",
              type: 'error'
            });
            this.roleClear();
            this.$emit('roleSelected',this.rId);
            return false;
          }else{
            let p = {parentId:this.rId,roleId:this.roleCurrentId};//请求参数
            roleIsParent(p, this.GLOBAL.header).then(result => {
              if (result.success) {
                let t = result.data;
                if(t>0){
                  this.$message({
                    message: "不能选择下级岗位作为上级",
                    type: 'error'
                  });
                  this.roleClear();
                  this.$emit('roleSelected',this.rId);
                  return false;
                }
                else{
                  this.$emit('roleSelected',this.rId);
                }
              }
            });
          }
        }else
        {
          this.$emit('roleSelected',this.rId);
        }
      },
      //清空项目
      proClear:function(){
        this.pId =null;
        return false;
      },
      //清空角色
      roleClear:function(){
        this.rId =null;
        return false;
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>
  .space {
    width: 200px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sysmanager/LinkageRole.vue